import { useState } from "react";
import type { PartnerTier } from "@tih/shared";
import { useReveal } from "../hooks/useReveal";
import { useSiteCopy } from "../context/SiteCopyContext";
import { CopyText } from "./CopyText";
import { getAtPath } from "../lib/siteCopyPaths";
import { PartnerForm } from "./forms/PartnerForm";

export function Partner() {
  const ref = useReveal<HTMLElement>();
  const { copy } = useSiteCopy();
  const tiers = copy.partner.tiers;
  const [openTier, setOpenTier] = useState<PartnerTier | null>(null);

  return (
    <section className="section section-partner" id="partner" ref={ref}>
      <div className="partner-inner">
        <div className="sec-eyebrow">
          <em>
            <CopyText path="partner.eyebrow" as="span" />
          </em>
        </div>
        <h2 className="sec-title sec-title-sm">
          <CopyText path="partner.title" as="span" />
        </h2>
        <p className="lede-serif">
          <CopyText path="partner.lede" as="span" />
        </p>
        <div className="partner-tiers">
          {tiers.map((t, i) => (
            <div className={`tier${t.feat ? " tier-feat" : ""}`} key={t.tier}>
              {t.tag && (
                <div className="tier-tag">
                  <CopyText path={`partner.tiers.${i}.tag`} as="span" />
                </div>
              )}
              <div className="tier-k">
                <CopyText path={`partner.tiers.${i}.k`} as="span" />
              </div>
              <div className="tier-v">
                <CopyText path={`partner.tiers.${i}.v`} as="span" />
              </div>
              <div className="tier-note">
                <CopyText path={`partner.tiers.${i}.note`} as="span" />
              </div>
              <button
                type="button"
                className={`btn btn-${t.variant}`}
                onClick={() => setOpenTier(openTier === t.tier ? null : t.tier)}
              >
                {openTier === t.tier
                  ? copy.common.close
                  : String(getAtPath(copy, `partner.tiers.${i}.cta`) ?? "")}
              </button>
            </div>
          ))}
        </div>
        {openTier && (
          <div style={{ marginTop: 28, maxWidth: 520 }}>
            <PartnerForm
              tier={openTier}
              defaultAmountUgx={tiers.find((t) => t.tier === openTier)!.amountUgx}
              onSuccess={() => setOpenTier(null)}
            />
          </div>
        )}
      </div>
    </section>
  );
}
